import React, { useState } from "react";
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

import servicioHttp from '../servicios/ServicioHttp';
import { esObjetoVacio } from '../servicios/ServicioObjetos';
import { TablaConsultas } from './TablaConsultas';

import servicioDescargaArchivos from '../servicios/ServicioDescargaArchivos';

const es = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "Mi", "J", "V", "S"],
    monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
};


const LA_PAGINACION = {
    registrosPorPagina: 20,
    conjunciones: {

    },
    betweenPropertyName: null,
    between: [],
    join: [
        "twCfdi",
        "twReceptor"
    ]
}

export const FomularioConsultas = () => {

    const estados = [
        { descripcion: 'Todas', id: 7},
        { descripcion: 'Activas', id: 1 },
        { descripcion: 'Canceladas', id: 6 }
       
      ];

    const [busqueda, setBusqueda] = useState({});
    const [estado, setEstado] = useState({});
    const [errores, setErrores] = useState({});
    const [paginacion, setPaginacion] = useState(LA_PAGINACION);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
      
        let elValor = value;
        
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
   

       
        setBusqueda(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));

        
    };


    const cambioEstado = (e) => {
        let elValor = e.target.value.id;
        setEstado(valoresPrevios => ({
            ...valoresPrevios,
            ['valor']: elValor
            
        }));
        
    }

    const buscar = () => {
        paginacion.numeroPagina=0;
        realizarBusqueda();
    }

    const realizarBusqueda= () => {
        agregarRestricciones();
        servicioHttp.consumirPostHttp('reportes/2023/buscar.json', paginacion).then(response => {
            setPaginacion(response.data.objeto);
        }).catch(error => {

        });
    }

    const reiniciar = () => {
        setBusqueda({});
        setPaginacion(LA_PAGINACION);
    }

    const descargarExcel = () => {
        servicioDescargaArchivos.descargaArchivo('/reportes/2023/reporte_total.json', paginacion);
    }

    const agregarRestricciones = () => {
        if (!esObjetoVacio(busqueda.fechaInicial) && !esObjetoVacio(busqueda.fechaFinal)) {
            paginacion.betweenPropertyName = "alias_twCfdi.fechaCreacion";
            paginacion.between[0] = busqueda.fechaInicial.getTime();
            paginacion.between[1] = busqueda.fechaFinal.getTime();
        }
        paginacion.conjunciones = {};
        if (!esObjetoVacio(busqueda.folio)) {
            paginacion.conjunciones['alias_twCfdi.folio'] = busqueda.folio;
        }
        if (!esObjetoVacio(busqueda.serie)) {
            paginacion.conjunciones['alias_twCfdi.serie'] = busqueda.serie;
        }

       
        if (!esObjetoVacio(busqueda.estado)) {
            
            paginacion.conjunciones['alias_twCfdi.estado'] = busqueda.estado.id;
         }

          if (!esObjetoVacio(busqueda.nru)) {
            if (!paginacion.join.includes("alias_twCfdi.twCruceses"))
                paginacion.join.push("alias_twCfdi.twCruceses");
            paginacion.conjunciones['alias_alias_twCfdi_twCruceses.nru'] = busqueda.nru;

        }
        if (!esObjetoVacio(busqueda.rfcReceptor)) {
            paginacion.conjunciones['alias_twReceptor.rfc'] = busqueda.rfcReceptor;
        }
    }

    return (
        <div>
            <div className="card card-w-title">
                <h1>Consulta de facturación</h1>
                <h5>En este modulo podrás consutar las facturas generadas de acuerdo a los siguientes criterios</h5>
                <h5>- Si eliges los criterios de fecha, entonces la fecha inicial y fecha final son requeridas</h5>
                <h5>- Puedes consultar solo por Serie, o solo por Folio o solo por Rfc de Receptor o solo por NRU</h5>
                <h5>- También puedes consultar por múltiples criterios, por ejemplo por Fecha Inicial y Final y por RFC de Receptor y por SERIE</h5>
                
                <div className="p-grid p-fluid">
                    <div className="p-col-12 p-md-6">
                        <h4> Fecha Inicial:</h4>
                        <Calendar id="fechaInicial" name="fechaInicial" value={busqueda.fechaInicial || ''}
                            onChange={(e) => handleChange(e, false)}
                            className={errores.fechaInicial ? 'p-error' : ''}
                            locale={es} dateFormat="yy-mm-dd" />
                        {errores.fechaInicial ? <div><br /> <Message severity="error"
                            text={errores.fechaInicial} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-6">
                        <h4> Fecha Final:</h4>
                        <Calendar id="fechaFinal" name="fechaFinal" value={busqueda.fechaFinal || ''}
                            onChange={(e) => handleChange(e, false)}
                            className={errores.fechaFinal ? 'p-error' : ''}
                            locale={es} dateFormat="yy-mm-dd" />
                        {errores.fechaFinal ? <div><br /> <Message severity="error"
                            text={errores.fechaFinal} /> </div> : null}
                    </div>

                    <div className="p-col-12 p-md-6">
                        <h4> Folio:</h4>
                        <InputText type="text" id="folio"
                            name="folio" value={busqueda.folio || ""}
                            className={errores.folio ? "p-error" : ""}
                            onChange={(e) => handleChange(e, false)} />
                    </div>

                    <div className="p-col-12 p-md-6">
                        <h4> Serie:</h4>
                        <InputText type="text" id="serie"
                            name="serie" value={busqueda.serie || ""}
                            className={errores.serie ? "p-error" : ""}
                            onChange={(e) => handleChange(e, false)} />
                    </div>

                    <div className="p-col-12 p-md-6">
                        <h4> NRU:</h4>
                        <InputText type="text" id="nru"
                            name="nru" value={busqueda.nru || ""}
                            className={errores.nru ? "p-error" : ""}
                            onChange={(e) => handleChange(e, false)} />
                    </div>
                    <div className="p-col-12 p-md-6">
                        <h4> Rfc de Receptor:</h4>
                        <InputText type="text" id="rfcReceptor"
                            name="rfcReceptor" value={busqueda.rfcReceptor || ""}
                            className={errores.rfcReceptor ? "p-error" : ""}
                            onChange={(e) => handleChange(e, false)} />
                    </div>

                    <div className="p-col-12 p-md-6">
                        <h4> Estado de la factura:</h4>
                        <Dropdown dataKey="id" id="estado"  name="estado"  value={busqueda.estado || ""}
                            className={errores.estado ? "p-error" : ""} options={estados} onChange={(e) => handleChange(e, false)} optionLabel="descripcion"  />
   
                    </div>
                    <div className="p-col-12 p-md-6">
                        </div>



                    <div className="p-col-12 p-md-4">
                        <Button
                            label="Buscar"
                            icon="pi pi-search"
                            onClick={buscar}
                            className="p-button-rounded p-button-success" />
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Button
                            label="Reiniciar formulario"
                            icon="pi pi-refresh"
                            onClick={reiniciar}
                            className="p-button-rounded p-button-info" />
                    </div>


                    {!esObjetoVacio(paginacion.datos) ? <div className="p-col-12 p-md-4">
                        <Button
                            label="Descargar Excel"
                            icon="pi pi-file-excel"
                            onClick={descargarExcel}
                            className="p-button-rounded p-button-warning" />
                    </div> : null}
                    

                </div>
            </div>
            <TablaConsultas paginacion={paginacion} funcionPaginacion={realizarBusqueda}/>
        </div>
    );
}